/* istanbul ignore file */
import { createSelector } from 'reselect'
export const extrasSelector = (state) => state.extras

export const extrasDataSelector = createSelector(
    extrasSelector,
    (extras) => extras ? extras.data : []
)
